<template>
  <div class="d-flex p-3 text-white bg-blur-darker justify-content-between align-items-center">
    <h5 class="mb-0">{{ header }}</h5>
    <button class="btn d-lg-none text-light me-3" type="button" @click.prevent="$parent.$emit('showNav')">
      <AVIcon icon="bars" />
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps({
  header: {
    type: String,
    required: true,
  },
});
</script>
